import { Box, Skeleton } from "@mui/joy";

import { AlbumCategoryCard } from "./AlbumCategoryCard";
import { AlbumGroup } from "./types";
import { ImageWithMetadata } from "../../constants/inspectionPhotos";

interface DesktopGroupsViewProps {
    groups: AlbumGroup[];
    taskId: string;
    projectId: string;
    loading: boolean;
    onGroupImagesChange: (label: string, images: ImageWithMetadata[]) => void;
}

export function DesktopGroupsView(props: DesktopGroupsViewProps) {
    const { groups, taskId, projectId, loading, onGroupImagesChange } = props;
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
                gap: 1.5,
            }}
        >
            {loading
                ? groups.map((group) => (
                      <Skeleton
                          key={group.id}
                          variant="rectangular"
                          sx={{ aspectRatio: "1/1", borderRadius: "4px" }}
                      />
                  ))
                : groups.map((group) => (
                      <AlbumCategoryCard
                          key={group.id}
                          group={group}
                          taskId={taskId}
                          projectId={projectId}
                          onImagesChange={(images) => onGroupImagesChange(group.label, images)}
                      />
                  ))}
        </Box>
    );
}
